import React from 'react'
import FormROValue from '../../../library/form/components/FormROValue1';

const ApiLogRow = (props) => {
    const { formObject, rowKey } = props;
    return (
        <li className='uiDivider'>
            <div className='uiSpacer5 uiBoxHiddenAction'>
                <div>
                    <div>
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "apiKey" }} className="uiSpacerH5 uiBlue uiUnHighlight" />
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "createdOn" }} className="uiSpacerH5 uiGrey uiUnHighlight" />
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "statusKey" }} className="uiGrey uiUnHighlight" />
                    </div>
                    <FormROValue customWrapper="div" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "actionKey" }} className="uiSpacerH5 uiSecondary" />
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "message" }} className="uiSpacerH5" />
                </div>
            </div>
        </li>
    )
}

export default ApiLogRow